import { useEffect, useState } from 'react'
import AdminLayout from '../../components/AdminLayout'
import { getProveedoresConStats, crearProveedor, actualizarProveedor } from '../../lib/stockApi'

const CATEGORIA_LABELS = {
  distribuidor_mayorista: '🏭 Distribuidor mayorista',
  fabricante_directo:     '🔧 Fabricante directo',
  imprenta:               '🖨️ Imprenta',
  empaque:                '📦 Empaque',
  servicios:              '🚚 Servicios',
  tecnologia:             '💻 Tecnología',
  otros:                  '📋 Otros',
  // Legacy (si quedó alguno sin migrar)
  mayorista:              '🏭 Mayorista',
  papel:                  '📄 Papel',
  quimicos:               '🧪 Químicos',
  cottonmax:              '🔧 Cottonmax/NEBA',
  bolsas:                 '📦 Bolsas',
}

export default function Proveedores() {
  const [proveedores, setProveedores] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(null)  // null | { proveedor: ... } (null para nuevo)

  useEffect(() => { load() }, [])

  async function load() {
    setLoading(true)
    setProveedores(await getProveedoresConStats())
    setLoading(false)
  }

  return (
    <AdminLayout>
      <div className="page">
        <h1>Proveedores</h1>
        <p className="lead">Quién nos vende qué · datos de contacto y cuenta</p>
        <div className="cards-grid" style={{ marginBottom: 16 }}>
          <div className="card">
            <h3>Total proveedores</h3>
            <div className="stat">{proveedores.length}</div>
          </div>
          <div className="card">
            <h3>Activos</h3>
            <div className="stat" style={{ color: 'var(--teal)' }}>{proveedores.filter(p => p.activo).length}</div>
          </div>
          <div className="card">
            <h3>Valor inventario total</h3>
            <div className="stat">${proveedores.reduce((s, p) => s + Number(p.valor_inventario), 0).toLocaleString('es-UY', { maximumFractionDigits: 0 })}</div>
            <div className="desc">Sumando todos los proveedores</div>
          </div>
        </div>

        <div className="btn-row">
          <button className="btn primary" onClick={() => setModal({ proveedor: null })}>+ Nuevo proveedor</button>
          <button className="btn ghost" onClick={load}>↺</button>
        </div>

        {loading ? (
          <div className="card" style={{ textAlign: 'center', color: 'var(--muted)' }}>Cargando...</div>
        ) : (
          <table className="t-table">
            <thead>
              <tr>
                <th>Proveedor</th>
                <th>Dirección · Horarios</th>
                <th>Contacto</th>
                <th style={{ textAlign: 'right' }}># Prod.</th>
                <th style={{ textAlign: 'right' }}>Valor stock</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {proveedores.map(p => (
                <tr key={p.id} style={{ opacity: p.activo ? 1 : 0.5 }}>
                  <td>
                    <div style={{ fontWeight: 700 }}>{p.nombre}</div>
                    <div style={{ display: 'flex', gap: 4, marginTop: 4, flexWrap: 'wrap' }}>
                      {(p.tipo_suministro || ['productos']).includes('productos') && (
                        <span style={{ background: '#dbeafe', color: '#1e40af', padding: '2px 8px', borderRadius: 999, fontSize: 10, fontWeight: 600 }}>📦 Productos</span>
                      )}
                      {(p.tipo_suministro || []).includes('materiales') && (
                        <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: 999, fontSize: 10, fontWeight: 600 }}>🧰 Materiales</span>
                      )}
                      {(p.tipo_suministro || []).includes('servicios') && (
                        <span style={{ background: '#fef3c7', color: '#854d0e', padding: '2px 8px', borderRadius: 999, fontSize: 10, fontWeight: 600 }}>🛠️ Servicios</span>
                      )}
                    </div>
                    {p.categoria && (
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{CATEGORIA_LABELS[p.categoria] || p.categoria}</div>
                    )}
                    {p.rut && <div style={{ fontSize: 11, color: 'var(--muted)', fontFamily: 'monospace' }}>RUT {p.rut}</div>}
                  </td>
                  <td style={{ fontSize: 12 }}>
                    {p.direccion && <div>📍 {p.direccion}</div>}
                    {p.horarios && <div style={{ color: 'var(--muted)', marginTop: 2 }}>🕐 {p.horarios}</div>}
                    {p.forma_pago && <div style={{ color: 'var(--muted)', marginTop: 2, fontSize: 11 }}>💳 {p.forma_pago.replace(/_/g, ' ')}</div>}
                    {!p.direccion && !p.horarios && '—'}
                  </td>
                  <td style={{ fontSize: 12 }}>
                    {p.contacto && <div style={{ fontWeight: 600 }}>{p.contacto}</div>}
                    {p.telefono && <div>📞 {p.telefono}</div>}
                    {p.email && <div style={{ color: 'var(--muted)' }}>✉️ {p.email}</div>}
                    {p.web && <div><a href={p.web} target="_blank" rel="noopener" style={{ fontSize: 11 }}>{p.web.replace(/^https?:\/\//, '').slice(0, 30)}</a></div>}
                    {!p.contacto && !p.telefono && !p.email && '—'}
                  </td>
                  <td style={{ textAlign: 'right', fontWeight: 700 }}>{p.productos_count}</td>
                  <td style={{ textAlign: 'right', fontSize: 13 }}>
                    ${Number(p.valor_inventario).toLocaleString('es-UY', { maximumFractionDigits: 0 })}
                  </td>
                  <td>
                    <span style={{ background: p.activo ? '#D1FAE5' : '#FEE2E2', color: p.activo ? '#065F46' : '#991B1B', padding: '3px 9px', borderRadius: 999, fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.06em' }}>
                      {p.activo ? '● Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td>
                    <button className="btn ghost" style={{ padding: '4px 10px', fontSize: 11 }} onClick={() => setModal({ proveedor: p })}>Editar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {modal !== null && (
          <ProveedorModal proveedor={modal.proveedor} onClose={() => setModal(null)} onDone={() => { setModal(null); load() }} />
        )}
      </div>
    </AdminLayout>
  )
}

function ProveedorModal({ proveedor, onClose, onDone }) {
  const esNuevo = !proveedor
  const [form, setForm] = useState({
    nombre: proveedor?.nombre || '',
    categoria: proveedor?.categoria || '',
    tipo_suministro: proveedor?.tipo_suministro?.length > 0 ? proveedor.tipo_suministro : ['productos'],
    contacto: proveedor?.contacto || '',
    telefono: proveedor?.telefono || '',
    email: proveedor?.email || '',
    direccion: proveedor?.direccion || '',
    horarios: proveedor?.horarios || '',
    rut: proveedor?.rut || '',
    web: proveedor?.web || '',
    forma_pago: proveedor?.forma_pago || '',
    notas: proveedor?.notas || '',
    activo: proveedor?.activo ?? true,
  })
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState(null)

  function toggleTipo(tipo) {
    setForm(f => {
      const nuevo = f.tipo_suministro.includes(tipo)
        ? f.tipo_suministro.filter(t => t !== tipo)
        : [...f.tipo_suministro, tipo]
      return { ...f, tipo_suministro: nuevo.length === 0 ? ['productos'] : nuevo }
    })
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setErr(null); setSaving(true)
    try {
      const clean = (s) => s?.trim() || null
      const datos = {
        nombre: form.nombre.trim(),
        categoria: clean(form.categoria),
        tipo_suministro: form.tipo_suministro,
        contacto: clean(form.contacto),
        telefono: clean(form.telefono),
        email: clean(form.email),
        direccion: clean(form.direccion),
        horarios: clean(form.horarios),
        rut: clean(form.rut),
        web: clean(form.web),
        forma_pago: clean(form.forma_pago),
        notas: clean(form.notas),
        activo: form.activo,
      }
      if (esNuevo) await crearProveedor(datos)
      else await actualizarProveedor(proveedor.id, datos)
      onDone()
    } catch (e) {
      setErr(e.message?.includes('duplicate') ? 'Ya existe un proveedor con ese nombre.' : e.message)
    } finally { setSaving(false) }
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,31,61,.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: 28, maxWidth: 600, width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
        <h2 style={{ marginBottom: 18 }}>{esNuevo ? 'Nuevo proveedor' : 'Editar proveedor'}</h2>
        <form onSubmit={handleSubmit}>

          <h3 className="section-head" style={{ marginTop: 0 }}>Identificación</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 12 }}>
            <Field label="Nombre" required>
              <input type="text" required value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Ej: Drogería Paysandú" />
            </Field>
            <Field label="Categoría">
              <select value={form.categoria} onChange={e => setForm({...form, categoria: e.target.value})}>
                <option value="">— ninguna —</option>
                <option value="distribuidor_mayorista">🏭 Distribuidor mayorista</option>
                <option value="fabricante_directo">🔧 Fabricante directo</option>
                <option value="imprenta">🖨️ Imprenta / impresión</option>
                <option value="empaque">📦 Empaque / packaging</option>
                <option value="servicios">🚚 Servicios (transporte, mantenimiento)</option>
                <option value="tecnologia">💻 Tecnología / software</option>
                <option value="otros">📋 Otros</option>
              </select>
            </Field>
          </div>
          <Field label="RUT">
            <input type="text" value={form.rut} onChange={e => setForm({...form, rut: e.target.value})} placeholder="216123450018" />
          </Field>

          <h3 className="section-head">¿Qué provee? *</h3>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', padding: '4px 0', marginBottom: 12 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', border: '1px solid ' + (form.tipo_suministro.includes('productos') ? '#00A8B5' : '#e2e8f0'), borderRadius: 8, background: form.tipo_suministro.includes('productos') ? '#ecfeff' : 'white', cursor: 'pointer', flex: 1, minWidth: 200 }}>
              <input type="checkbox" checked={form.tipo_suministro.includes('productos')} onChange={() => toggleTipo('productos')} style={{ width: 'auto', margin: 0 }} />
              <span style={{ fontSize: 13 }}>📦 <b>Productos</b><br/><span style={{ color: '#64748b', fontSize: 11 }}>Mercadería para revender al cliente</span></span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', border: '1px solid ' + (form.tipo_suministro.includes('materiales') ? '#00A8B5' : '#e2e8f0'), borderRadius: 8, background: form.tipo_suministro.includes('materiales') ? '#ecfeff' : 'white', cursor: 'pointer', flex: 1, minWidth: 200 }}>
              <input type="checkbox" checked={form.tipo_suministro.includes('materiales')} onChange={() => toggleTipo('materiales')} style={{ width: 'auto', margin: 0 }} />
              <span style={{ fontSize: 13 }}>🧰 <b>Materiales</b><br/><span style={{ color: '#64748b', fontSize: 11 }}>Insumos operativos (bolsas, etiquetas, etc.)</span></span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', border: '1px solid ' + (form.tipo_suministro.includes('servicios') ? '#00A8B5' : '#e2e8f0'), borderRadius: 8, background: form.tipo_suministro.includes('servicios') ? '#ecfeff' : 'white', cursor: 'pointer', flex: 1, minWidth: 200 }}>
              <input type="checkbox" checked={form.tipo_suministro.includes('servicios')} onChange={() => toggleTipo('servicios')} style={{ width: 'auto', margin: 0 }} />
              <span style={{ fontSize: 13 }}>🛠️ <b>Servicios</b><br/><span style={{ color: '#64748b', fontSize: 11 }}>Software, infraestructura, honorarios, banca, telco, etc.</span></span>
            </label>
          </div>

          <h3 className="section-head">Contacto</h3>
          <Field label="Persona de contacto">
            <input type="text" value={form.contacto} onChange={e => setForm({...form, contacto: e.target.value})} placeholder="Juan Pérez" />
          </Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Field label="Teléfono">
              <input type="tel" value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} placeholder="+598 2..." />
            </Field>
            <Field label="Email">
              <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="ventas@..." />
            </Field>
          </div>
          <Field label="Web / catálogo online">
            <input type="url" value={form.web} onChange={e => setForm({...form, web: e.target.value})} placeholder="https://..." />
          </Field>

          <h3 className="section-head">Operación</h3>
          <Field label="Dirección física">
            <input type="text" value={form.direccion} onChange={e => setForm({...form, direccion: e.target.value})} placeholder="Av. Italia 1234, Montevideo" />
          </Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Field label="Horarios">
              <input type="text" value={form.horarios} onChange={e => setForm({...form, horarios: e.target.value})} placeholder="Lun-Vie 9 a 18hs" />
            </Field>
            <Field label="Forma de pago">
              <select value={form.forma_pago} onChange={e => setForm({...form, forma_pago: e.target.value})}>
                <option value="">— elegir —</option>
                <option value="contado">Contado al retirar</option>
                <option value="transferencia">Transferencia</option>
                <option value="cheque">Cheque</option>
                <option value="cuenta_corriente_15">Cuenta corriente 15 días</option>
                <option value="cuenta_corriente_30">Cuenta corriente 30 días</option>
                <option value="cuenta_corriente_60">Cuenta corriente 60 días</option>
              </select>
            </Field>
          </div>

          <h3 className="section-head">Otros</h3>
          <Field label="Notas (código de cliente, condiciones especiales, etc.)">
            <textarea value={form.notas} onChange={e => setForm({...form, notas: e.target.value})} rows="3" placeholder="Cód. cliente: 1234 · Pedidos por WhatsApp · Entrega martes/jueves" />
          </Field>
          <Field label="Estado">
            <label style={{ fontSize: 14 }}>
              <input type="checkbox" checked={form.activo} onChange={e => setForm({...form, activo: e.target.checked})} style={{ width: 'auto', marginRight: 8 }} />
              Proveedor activo
            </label>
          </Field>

          {err && <div className="err-box">{err}</div>}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
            <button type="button" className="btn ghost" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn primary" disabled={saving}>{saving ? 'Guardando...' : (esNuevo ? 'Crear proveedor' : 'Guardar cambios')}</button>
          </div>
        </form>
      </div>
    </div>
  )
}

function Field({ label, children, required }) {
  return (
    <label style={{ display: 'block', marginBottom: 12 }}>
      <b style={{ display: 'block', fontSize: 11, fontWeight: 700, color: 'var(--navy-ink)', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 5 }}>
        {label} {required && <span style={{ color: 'var(--err)' }}>*</span>}
      </b>
      {children}
    </label>
  )
}
